<template>
  <c-box>
    <wizard-tab
      v-for="tab in tabData"
      :key="`return_tab_${tab.step}`"
      path="/support/returns/new"
      :step="tab.step"
      :current-step="currentStep"
      :data-cy="tab.dataCy"
      :disabled="tab.isDisabled || !tab.isActivated"
      :errored="tab.errors"
      v-chakra
    >
      {{ tab.step }}. {{ tab.title }}
    </wizard-tab>
  </c-box>
</template>
<script lang="ts">
import { defineComponent, PropType } from "vue";
import { CBox } from "@chakra-ui/vue";
import WizardTab from "@/components/WizardTab.vue";

export default defineComponent({
  name: "ReturnTabs",
  components: {
    CBox,
    WizardTab,
  },
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
    tabData: {
      type: Array as PropType<any>,
      required: true,
    },
  },
});
</script>
